export const EUserProfileValues = {
  ENABLED_FEATURES: "EnabledFeatures",
};

export const EEnabledFeatures = {
  PRINT: "print",
  DOWNLOAD_PDF: "downloadPdf",
};

export const CmpType = {
  DIDOMI: "didomi",
  LMO: "lmo",
  SOURCEPOINT: "sourcepoint",
};

export const XitiMode = {
  MINIMAL: "minimal",
  FULL: "full",
};

export const deviceType = {
  PHONE: "smartphone",
  TABLET: "tablet",
  DESKTOP: "desktop",
};

export const EErrorOrigin = {
  VALIDATESUBSCRIPTION: "validateSubscription",
  VALIDATESUBSCRIPTIONTOKEN: "validateSubscriptionToken",
  REQUESTDOWNLOAD: "requestDownload",
  CONFIRMDOWNLOAD: "confirmDownload",
  REQUESTORDER: "requestOrder",
  PAYWALL: "paywall",
  OPENSESSION: "openSession",
};

export const EErrorType = {
  AUTHORIZATION: "authorization",
  AUTHENTICATION: "authentication",
};

export const EValidateSubscriptionTokenErrorCode = {
  CALL_FAILED: "VST-ERR",
  UNSUCCESSFULL: "VST-KO",
  STATUS_NOT_A_STRING: "VST-SM",
};

export const EValidateSubscriptionErrorCode = {
  STATUS_NOT_A_STRING: "VS-SM",
  UNSUCCESSFULL: "VS-KO",
  CALL_FAILED: "VS-ERR",
};

export const ERequestDownloadErrorCode = {
  STATUS_NOT_A_STRING: "RD-SM",
  UNSUCCESSFULL: "RD-KO",
  CALL_FAILED: "RD-ERR",
};

export const EPaywallErrorCode = {
  NOT_ALL_FIELDS_FILLED: "PW-FIELDS",
  WRONG_EMAIL: "PW-EMAIL",
};

export const EConfirmDownloadErrorCode = {
  STATUS_NOT_A_STRING: "CD-SM",
  UNSUCCESSFULL: "CD-KO",
  CALL_FAILED: "CD-ERR",
};

export const EOpenSessionError = {
  NO_SESSION_INFO: "OS-SI",
  UNSUCCESSFULL: "OS-KO",
  CALL_FAILED: "OS-ERR",
};

//TODO: should be removed when RO call is removed
export const ERequestOrderErrorCode = {
  STATUS_NOT_A_STRING: "RO-SM",
  UNSUCCESSFULL: "RO-KO",
  CALL_FAILED: "RO-ERR",
};

export const EAuthenticationType = {
  SSO: "sso",
  STATE: "state", //used by LUX could become Auth0
  AUTH0: "auth0",
  DEFAULT: "default",
};

export const EErrorName = {
  AUTHENTICATION_AUTHORISATION: "AuthenticationAuthorizationError",
  OPEN_SESSION: "OpenSessionError",
};



// WEBPACK FOOTER //
// ./src/common/utilities/enums.js